import { createSlice } from '@reduxjs/toolkit';

import { getOrderById } from './action';
import { IOrderDetailState } from './model';

const initialState: IOrderDetailState = {
  order: {
    loading: false,
    data: null,
    errors: null,
  },
};

export const orderDetailSlice = createSlice({
  name: 'landing/order',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrderById.pending, (state) => {
        state.order.loading = true;
      })
      .addCase(getOrderById.fulfilled, (state, action) => {
        state.order.loading = false;
        state.order.data = action.payload;
        state.order.errors = action.payload?.messages;
      })
      .addCase(getOrderById.rejected, (state) => {
        state.order.loading = false;
      });
  },
});

// export const { } = orderDetailSlice.actions;

export default orderDetailSlice.reducer;
